import type { SavedContentMutationParams } from '../types';
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '@workramp/ui';
import { useDefaultMutation } from '~/lib/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { I18n } from '~/common/explicit-exports';
import { savedContentKeys } from '../utils';
import { SAVED_CONTENT_API_ROOT } from '../constants';

export function addSavedContent({ id, type }: SavedContentMutationParams): Promise<boolean> {
  return FetchPromise.post(`${SAVED_CONTENT_API_ROOT}`, { content_id: id, content_type: type });
}

export function useAddSavedContentMutation() {
  const toast = useToast();
  const queryClient = useQueryClient();
  return useDefaultMutation(addSavedContent, {
    onSuccess: async () => {
      toast.open({ children: I18n.t('js.learner.saved_content.added_to_saved_content') });
      await queryClient.invalidateQueries(savedContentKeys.content());
    },
  });
}
